/**
 * @generated SignedSource<<676649549cad06e59ccf04da26cea744>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type LessonKind = "ARTICLE" | "AUDIO_ARTICLE" | "COMMENTARY" | "MINI_STORY" | "POV" | "VOCABULARY" | "%future added value";
export type LessonTodayCardQuery$variables = {
  localDay: any;
};
export type LessonTodayCardQuery$data = {
  readonly me: {
    readonly learner: {
      readonly activeLessonSet: {
        readonly day: number | null | undefined;
        readonly id: string;
        readonly lessons: ReadonlyArray<{
          readonly completedToday: boolean;
          readonly id: string;
          readonly kind: LessonKind;
          readonly part: string | null | undefined;
          readonly playsToday: number;
        }>;
        readonly level: number | null | undefined;
        readonly name: string;
        readonly position: number;
      } | null | undefined;
      readonly defaultCharacter: {
        readonly audience: string;
      } | null | undefined;
      readonly id: string;
      readonly lessonSets: ReadonlyArray<{
        readonly id: string;
        readonly position: number;
      }>;
    } | null | undefined;
  } | null | undefined;
};
export type LessonTodayCardQuery = {
  response: LessonTodayCardQuery$data;
  variables: LessonTodayCardQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "localDay"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "audience",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "position",
  "storageKey": null
},
v4 = [
  {
    "kind": "Variable",
    "name": "localDay",
    "variableName": "localDay"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "LessonSet",
  "kind": "LinkedField",
  "name": "activeLessonSet",
  "plural": false,
  "selections": [
    (v1/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "level",
      "storageKey": null
    },
    (v3/*:: as any*/),
    {
      "alias": null,
      "args": (v4/*:: as any*/),
      "kind": "ScalarField",
      "name": "day",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Lesson",
      "kind": "LinkedField",
      "name": "lessons",
      "plural": true,
      "selections": [
        (v1/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "kind",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "part",
          "storageKey": null
        },
        {
          "alias": null,
          "args": (v4/*:: as any*/),
          "kind": "ScalarField",
          "name": "playsToday",
          "storageKey": null
        },
        {
          "alias": null,
          "args": (v4/*:: as any*/),
          "kind": "ScalarField",
          "name": "completedToday",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "LessonSet",
  "kind": "LinkedField",
  "name": "lessonSets",
  "plural": true,
  "selections": [
    (v1/*:: as any*/),
    (v3/*:: as any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LessonTodayCardQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Learner",
            "kind": "LinkedField",
            "name": "learner",
            "plural": false,
            "selections": [
              (v1/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Character",
                "kind": "LinkedField",
                "name": "defaultCharacter",
                "plural": false,
                "selections": [
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              },
              (v5/*:: as any*/),
              (v6/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "LessonTodayCardQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Learner",
            "kind": "LinkedField",
            "name": "learner",
            "plural": false,
            "selections": [
              (v1/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Character",
                "kind": "LinkedField",
                "name": "defaultCharacter",
                "plural": false,
                "selections": [
                  (v2/*:: as any*/),
                  (v1/*:: as any*/)
                ],
                "storageKey": null
              },
              (v5/*:: as any*/),
              (v6/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ff9f78c7b9729faf2966e862a0642ff3",
    "id": null,
    "metadata": {},
    "name": "LessonTodayCardQuery",
    "operationKind": "query",
    "text": "query LessonTodayCardQuery(\n  $localDay: NaiveDate!\n) {\n  me {\n    learner {\n      id\n      defaultCharacter {\n        audience\n        id\n      }\n      activeLessonSet {\n        id\n        name\n        level\n        position\n        day(localDay: $localDay)\n        lessons {\n          id\n          kind\n          part\n          playsToday(localDay: $localDay)\n          completedToday(localDay: $localDay)\n        }\n      }\n      lessonSets {\n        id\n        position\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8dbdaf8cd64c7b62205717f85e2aa30c";

export default node;
